/**
 * @file Identity Avatar component.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import omit from 'lodash.omit';

import Avatar from '../Avatar';
import * as AVATAR_SIZES from '../../../constants/avatar-sizes';
import { getAsset } from '../../../util/assets';

class IdentityAvatar extends Component {
  static propTypes = {
    identity: PropTypes.shape({
      id: PropTypes.string,
      current_photo: PropTypes.object,
      current_matching_photo: PropTypes.object,
    }),
    uploadedPhoto: PropTypes.shape({
      id: PropTypes.string,
      url: PropTypes.string,
    }),
    size: PropTypes.oneOf(Object.values(AVATAR_SIZES)),
    className: PropTypes.string,
    selfieType: PropTypes.oneOf(['avatar', 'matching', 'any']),
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.arrayOf(PropTypes.nodes),
    ]),
    onClick: PropTypes.func,
    selected: PropTypes.bool,
    withCheckmark: PropTypes.bool,
    title: PropTypes.string,
  };

  static defaultProps = {
    size: AVATAR_SIZES.AVATAR_SIZE_42,
    selfieType: 'avatar',
    withCheckmark: true,
  };

  getPhoto() {
    const { identity, selfieType, uploadedPhoto } = this.props;

    if (uploadedPhoto) {
      return {
        thumbnail_urls: [{ url: uploadedPhoto.url, width: 0, height: 0 }],
      };
    }

    if (!identity) {
      return {
        thumbnail_urls: [
          { url: getAsset('/user-menu-default.png'), width: 0, height: 0 },
        ],
      };
    }

    if (identity.current_photo && selfieType === 'avatar') {
      return identity.current_photo;
    }

    if (identity.current_matching_photo && selfieType === 'matching') {
      return identity.current_matching_photo;
    }

    if (selfieType === 'any') {
      return identity.current_photo || identity.current_matching_photo || null;
    }

    return null;
  }

  render() {
    const {
      children,
      onClick,
      className,
      selected,
      withCheckmark,
      title,
      ...props
    } = this.props;

    const classes = classNames({
      'identity-avatar-container': true,
      'btn-reset': true,
      [className]: !!className,
    });

    return (
      <button
        className={classes}
        onClick={onClick}
        title={title}
        {...omit(props, 'selfieType')}
      >
        <Avatar
          size={this.props.size}
          photo={this.getPhoto()}
          selected={selected}
          withCheckmark={withCheckmark}
        />
        {children}
      </button>
    );
  }
}

export default IdentityAvatar;
